import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faUnlockAlt, faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { Form, Button, Alert, InputGroup } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import AkasbLogo from "../../assets/img/logo_akasb.png";
import { jwtDecode } from "jwt-decode";

const Signin = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [erro, setErro] = useState("");
    const [rememberMe, setRememberMe] = useState(false);
    const [loading, setLoading] = useState(false);

    const history = useHistory();
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

    const clearTokens = () => {
        localStorage.removeItem("token"); localStorage.removeItem("refreshToken");
        sessionStorage.removeItem("token"); sessionStorage.removeItem("refreshToken");
    };

    useEffect(() => {
        const token = localStorage.getItem("token") || sessionStorage.getItem("token");
        if (!token) return;
        try {
            const decoded = jwtDecode(token);
            const role = decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"]?.toLowerCase();
            const isAtivo = decoded["isAtivo"] === "1";
            if (!role) { clearTokens(); return; }
            if (["admin", "treinador", "tesoureiro"].includes(role)) history.replace("/connect/dashboard/admin");
            else if (role === "user") history.replace(isAtivo ? "/connect/dashboard/user" : "/connect/praticantes/user");
        } catch { clearTokens(); }
    }, [history]);

    const handleLogin = async (e) => {
        e.preventDefault();
        setErro(""); setLoading(true);
        try {
            const response = await fetch(`${API_BASE_URL}/auth/login`, {
                method: "POST",
                headers: { "Content-Type": "application/json", "Accept": "application/json" },
                body: JSON.stringify({ email, password })
            });
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || "Credenciais inválidas.");
            }
            const data = await response.json();

            // Definição clara do storage com base no checkbox
            const storage = rememberMe ? localStorage : sessionStorage;
            storage.setItem("token", data.token);
            storage.setItem("refreshToken", data.refreshToken);

            const decoded = jwtDecode(data.token);
            const role = decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"]?.toLowerCase();
            const isAtivo = decoded["isAtivo"] === "1";

            if (["admin", "treinador", "tesoureiro"].includes(role)) history.replace("/connect/dashboard/admin");
            else if (role === "user") history.replace(isAtivo ? "/connect/dashboard/user" : "/connect/praticantes/user");
            else history.replace("/connect/login");
        } catch (err) {
            setErro(err.message || "Erro inesperado no login.");
        } finally { setLoading(false); }
    };

    const inputStyle = { border: "1.5px solid #e9ecef", height: 50, fontSize: 15, background: "#f8f9fa" };
    const prefixStyle = { background: "#f8f9fa", border: "1.5px solid #e9ecef", borderRight: "none" };

    return (
        <main style={{ minHeight: "100vh", background: "linear-gradient(135deg, #1e1d45 0%, #2d2c6b 100%)", display: "flex", alignItems: "center", justifyContent: "center", padding: "20px" }}>
            <div style={{ width: "100%", maxWidth: 420 }}>
                <div style={{ textAlign: "center", marginBottom: 32 }}>
                    <img src={AkasbLogo} alt="AKASB" style={{ width: 68, marginBottom: 14 }} />
                    <div style={{ color: "white", fontSize: 22, fontWeight: 900, letterSpacing: 2, fontFamily: "'Anton', sans-serif" }}>AKASB</div>
                    <div style={{ color: "rgba(255,255,255,0.45)", fontSize: 13, marginTop: 4 }}>Plataforma de Gestão</div>
                </div>

                <div style={{ background: "white", borderRadius: 20, padding: "36px 32px", boxShadow: "0 24px 60px rgba(0,0,0,0.3)" }}>
                    <h2 style={{ fontWeight: 800, fontSize: 22, color: "#1e1d45", marginBottom: 4 }}>Bem-vindo de volta</h2>
                    <p style={{ color: "#9ca3af", fontSize: 14, marginBottom: 28 }}>Entre na sua conta para continuar</p>

                    {erro && <Alert variant="danger" style={{ borderRadius: 12, fontSize: 14 }}>{erro}</Alert>}

                    <Form onSubmit={handleLogin}>
                        <Form.Group className="mb-3">
                            <Form.Label style={{ fontWeight: 600, fontSize: 13, color: "#374151" }}>Email</Form.Label>
                            <InputGroup>
                                <InputGroup.Text style={prefixStyle}><FontAwesomeIcon icon={faEnvelope} style={{ color: "#9ca3af" }} /></InputGroup.Text>
                                <Form.Control autoFocus required type="email" placeholder="o.seu@email.com" value={email} onChange={e => setEmail(e.target.value)} style={{ ...inputStyle, borderLeft: "none" }} />
                            </InputGroup>
                        </Form.Group>

                        <Form.Group className="mb-4">
                            <Form.Label style={{ fontWeight: 600, fontSize: 13, color: "#374151" }}>Password</Form.Label>
                            <InputGroup>
                                <InputGroup.Text style={prefixStyle}><FontAwesomeIcon icon={faUnlockAlt} style={{ color: "#9ca3af" }} /></InputGroup.Text>
                                <Form.Control required type="password" placeholder="A sua password" value={password} onChange={e => setPassword(e.target.value)} style={{ ...inputStyle, borderLeft: "none" }} />
                            </InputGroup>
                        </Form.Group>

                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
                            <Form.Check
                                type="checkbox"
                                id="rememberMe"
                                label="Lembrar-me"
                                checked={rememberMe}
                                onChange={(e) => setRememberMe(e.target.checked)}
                                style={{ fontSize: 13, color: "#6b7280", cursor: "pointer" }}
                            />
                            <Link to="/connect/forgot-password" style={{ fontSize: 13, color: "#1e1d45", fontWeight: 600, textDecoration: "none" }}>
                                Esqueceu a password?
                            </Link>
                        </div>

                        <Button type="submit" disabled={loading} style={{ width: "100%", height: 50, background: loading ? "#6b7280" : "#1e1d45", border: "none", borderRadius: 12, color: "white", fontWeight: 700, fontSize: 15, cursor: loading ? "not-allowed" : "pointer" }}>
                            {loading ? "A entrar..." : "Entrar"}
                        </Button>
                    </Form>

                    <div style={{ textAlign: "center", marginTop: 24, fontSize: 14, color: "#9ca3af" }}>
                        Ainda não tem conta?{" "}
                        <Link to="/connect/register" style={{ color: "#1e1d45", fontWeight: 700, textDecoration: "none" }}>Criar conta</Link>
                    </div>
                </div>

                <div style={{ textAlign: "center", marginTop: 24 }}>
                    <Link to="/" style={{ color: "rgba(255,255,255,0.45)", fontSize: 13, textDecoration: "none", display: "inline-flex", alignItems: "center", gap: 6 }}>
                        <FontAwesomeIcon icon={faAngleLeft} /> Voltar à página inicial
                    </Link>
                </div>
            </div>
        </main>
    );
};

export default Signin;